import axiosInstance from "@/api/axiosInstance";
import {
  BulkUpdateEventSessionAttendanceRequest,
  BulkUpdateEventSessionAttendanceResponse,
} from "./types";

export const bulkUpdateEventSessionAttendance = async (
  data: BulkUpdateEventSessionAttendanceRequest,
): Promise<BulkUpdateEventSessionAttendanceResponse> => {
  const response = await axiosInstance.patch(
    "/api/private/event-session-attendance/bulk-update",
    data,
  );

  return response.data;
};
